<template>
    <div>
        <div class="row mb-8">
            <div class="col-6 d-flex justify-content-start">
                <v-card-title>
                    {{ $t('Delivery.initializedDeliveryOrders') }}
                </v-card-title>
            </div>
            <div class="col-6 d-flex justify-content-end">

                <!-- <v-chip class="button1 text-left" style="cursor: default;" elevation="4" variant="outlined" rounded="xl"
                    color="primary" :closable="true" @click:close="removeTag">
                    {{ GroupedClientOrder.length }}
                </v-chip> -->

                <!-- Selected : {{ GroupedClientOrder.length }} => {{ GroupedClientOrder }} -->
                <genericBtnComponent :ClickFun="OpenCreateDeliveryOrders" svg="2"
                    :Title="$t('Delivery.initializedDeliveryOrders')" :disable="GroupedClientOrder.length == 0" />

            </div>
        </div>
        <v-card elevation="0">
            <DelivryOrdersList ref="DelivryOrdersList" @GroupedClientOrder="handleGroupedClientOrder" />
        </v-card>
    </div>



    <v-dialog v-model="Dialog_CreateDeliveryOrders" v-if="Dialog_CreateDeliveryOrders">
        <v-card elevation="0" width="700px" class="py-2 px-4" style="border-radius: 12px">
            <v-card-title class="justify-content-center mb-2">
                <span class="title">
                    <!-- To translate -->
                    Add delivery Order ( {{ GroupedClientOrder.length }} items )
                </span>
            </v-card-title>

            <!-- <v-chip class="button1 text-left" style="cursor: default;" elevation="4" variant="outlined" rounded="xl"
                color="primary" :closable="true" @click:close="removeTag">
                {{ GroupedClientOrder.length }}
            </v-chip>

            Selected : {{ GroupedClientOrder.length }} => {{ GroupedClientOrder }} -->

            <div class="row justify-content-start mb-2">
                <div class="col">
                    <v-card-title class="text-left">
                        {{ $t("Delivery.DeliveryOrders.Title") }}
                        <span class="red">*</span>
                    </v-card-title>
                    <v-text-field v-model="DeliveryOrderName" id="Title" name="Title" maxlength="30" hide-details
                        :placeholder="$t('placeholder.enter', { itm: $t('Delivery.DeliveryOrders.Title'), })"
                        persistent-placeholder variant="outlined" class="rounded-xl"></v-text-field>
                    <span v-if="msg.DeliveryOrderName" class="warningHint" id="WarningMsgReference">
                        {{ msg.DeliveryOrderName }}
                    </span>
                </div>
            </div>

            <div class="row justify-content-start mb-2">
                <div class="col">
                    <v-card-title class="text-left">
                        {{ $t("Delivery.companyName") }}
                        <span class="red">*</span>
                    </v-card-title>
                    <v-autocomplete id="Company" name="companyName" variant="outlined" v-model="companyId"
                        persistent-placeholder
                        :placeholder="$t('placeholder.select', { itm: $t('Delivery.companyName'), })" :items="Companies"
                        item-title="companyName" item-value="id" hide-details :readonly="isEditMode"
                        :class="isEditMode ? 'readonly-field' : ''">
                        <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" variant="text">
                                {{ item.companyName }}
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                    <span v-if="msg.companyName" class="warningHint" id="WarningMsgReference">
                        {{ msg.companyName }}
                    </span>
                </div>
            </div>

            <div class="row justify-content-start mb-2">
                <div class="col">
                    <v-card-title class="text-left">
                        {{ $t("PickupPoint.PickupPoint") }}
                    </v-card-title>
                    <v-autocomplete id="PickupPoint" name="PickupPoint" variant="outlined"
                        v-model="IdPickupPointLocation" persistent-placeholder
                        :placeholder="$t('placeholder.select', { itm: $t('PickupPoint.PickupPoint'), })"
                        :items="PickupPointLocation" item-title="locationName" item-value="idPickupPointLocation"
                        hide-details :readonly="isEditMode" :class="isEditMode ? 'readonly-field' : ''">
                        <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" variant="text">
                                {{ item.LocationName }}
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </div>
            </div>

            <card-actions :yes="CreateDeliveryOrders" v-model:no="Dialog_CreateDeliveryOrders" :loader="loader"
                :yesDisable="loader" width="300px" :yesTitle="$t('actions.save')" />
        </v-card>
    </v-dialog>

</template>
<script>
import { CreateDeliveryOrder, getDeliveryCompanies, isClient, isDelivery } from "@/api";
import DelivryOrdersList from "./initializedDeliveryOrdersList.vue";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import cardActions from "@/genericComponent/cardActions.vue";

export default {
    components: {
        DelivryOrdersList,
        genericBtnComponent,
        cardActions
    },
    data() {
        return {
            GroupedClientOrder: [],
            Dialog_CreateDeliveryOrders: false,
            msg: [],
            Companies: [],
            companyId: null,
            DeliveryOrderName: null,
            loader: false

        }
    },
    mounted() {
        this.getCompanies();
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.DeliveryOrders');
    },
    methods: {
        OpenCreateDeliveryOrders() {
            this.Dialog_CreateDeliveryOrders = true;
        },
        CreateDeliveryOrders() {
            this.loader = true;
            this.msg["companyName"] = "";
            this.msg["DeliveryOrderName"] = "";

            if (this.companyId == null) {
                this.msg["companyName"] = this.$t("warningInput.isrequired", {
                    itm: this.$t("Brands.Name"),
                });
            }
            if (this.DeliveryOrderName == null) {
                this.msg["DeliveryOrderName"] = this.$t("warningInput.isrequired", {
                    itm: this.$t("Delivery.DeliveryOrders.Title"),
                });
            }

            if (this.msg["DeliveryOrderName"] == "" && this.msg["companyName"] == "")  {
                CreateDeliveryOrder(this.GroupedClientOrder, this.DeliveryOrderName, this.IdPickupPointLocation, this.companyId)
                    .then(() => {
                        this.ActiveSavedSnackBar();
                        this.Dialog_CreateDeliveryOrders = false;
                        this.$refs.DelivryOrdersList.fetchDeliveryOrders();
                    })
                    .catch((error) => {
                        this.ActiveWarningSnackBar();
                        console.error(error);
                    });
            }
            this.loader = false;
        },
        handleGroupedClientOrder(value) {
            this.GroupedClientOrder = value;
        },
        removeTag() {
            this.$refs.DelivryOrdersList.removeGrouped();
        },
        isDelivery() {
            return isDelivery();
        },
        IsClient() {
            return isClient();
        },
        getCompanies() {
            if (this.IsClient()) {
                getDeliveryCompanies()
                    .then((response) => {
                        this.Companies = response.data;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        },
        ActiveWarningSnackBar() {
            this.getParent("MainLayout").ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent("MainLayout").ActiveSavedSnackBar();
        },
        ActiveDeletedSnackBar() {
            this.getParent("MainLayout").ActiveDeletedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== "undefined") {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
    }
};

</script>

<style>
.button1 {
    color: white;
    font-family: Inter;
    font-size: 12px;
    font-weight: 500;
    line-height: 15px;
    letter-spacing: 0.01em;
    text-align: left;
    border: 5px;
    border-color: black;
}
</style>
